module.exports = __webpack_public_path__ + "static/media/editIcon.37cc72a0.svg";